import { render, staticRenderFns } from "./ShippingCompanies.vue?vue&type=template&id=ea889e3c&scoped=true"
import script from "./ShippingCompanies.vue?vue&type=script&lang=js"
export * from "./ShippingCompanies.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea889e3c",
  null
  
)

export default component.exports